'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { useMemo } from 'react';
import { Global } from '@s7/styles';
import { CLASSNAME_NO_SCROLLBAR, DATA_SCROLL_LOCKED, CLASSNAME_ZERO_RIGHT, CLASSNAME_FULL_WIDTH, VAR_REMOVED_BAR_SIZE } from './RemoveScrollBarGlobal.contract.js';
import { useLockAttribute } from './useLockAttribute.js';
import { getGapWidth } from './utils.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const RemoveScrollBarGlobal = (props)=>{
    const { noRelative, noImportant } = props;
    useLockAttribute();
    const [left, top, right, gap] = useMemo(getGapWidth, []);
    const important = !noImportant ? ' !important' : '';
    const overflow = 'hidden' + important;
    const rightGap = `${gap}px` + important;
    const zeroRightGap = 0 + important;
    return /*#__PURE__*/ jsx(Global, {
        styles: {
            [`.${CLASSNAME_NO_SCROLLBAR}`]: {
                overflow,
                paddingRight: `${gap}px` + important
            },
            [`body[${DATA_SCROLL_LOCKED}]`]: _extends({
                overflow,
                overscrollBehavior: 'contain'
            }, !noRelative && {
                position: 'relative' + important
            }, {
                paddingLeft: left,
                paddingTop: top,
                paddingRight: right,
                marginLeft: 0,
                marginTop: 0,
                marginRight: rightGap,
                [VAR_REMOVED_BAR_SIZE]: `${gap}px`
            }),
            [`.${CLASSNAME_ZERO_RIGHT}`]: {
                right: rightGap
            },
            [`.${CLASSNAME_FULL_WIDTH}`]: {
                marginRight: rightGap
            },
            [`.${CLASSNAME_ZERO_RIGHT} .${CLASSNAME_ZERO_RIGHT}`]: {
                right: zeroRightGap
            },
            [`.${CLASSNAME_FULL_WIDTH} .${CLASSNAME_FULL_WIDTH}`]: {
                marginRight: zeroRightGap
            }
        }
    });
};

export { RemoveScrollBarGlobal };
//# sourceMappingURL=RemoveScrollBarGlobal.js.map
